<div class="container">
  <div [class.selected]="selectedTab === 'unit-of-measure'">
    {{ 'i18n.menuProfitPro.ingredientDetails.units' | translate }}
  </div>
  <ion-icon
    *ngIf="shouldShowZeroCostIcon()"
    data-cy="cost-information-icon"
    color="danger"
    name="information-circle"
    class="uofm-icon"
  ></ion-icon>
</div>
